import { tokens } from 'styling/tokens'

export const ChartTooltip = ({ active, payload, label, formatter }: any) => {
  if (!active || !payload?.length) return null
  return (
    <div
      style={{
        background: tokens.surface.raised,
        border: `1px solid ${tokens.border.hairline}`,
        borderRadius: tokens.radius.control,
        padding: '0.5rem 0.75rem',
        boxShadow: tokens.shadow.card,
      }}
    >
      <div style={{ color: tokens.text.primary, fontSize: 12, fontWeight: 600, marginBottom: 4 }}>{label}</div>
      {payload.map((p: any) => (
        <div key={p.name} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, lineHeight: 1.6 }}>
          <span style={{ width: 8, height: 8, borderRadius: 2, background: p.color ?? p.stroke, flex: 'none' }} />
          <span style={{ color: tokens.text.secondary }}>{p.name}</span>
          <span style={{ color: tokens.text.primary, fontWeight: 600, marginLeft: 'auto', paddingLeft: 12 }}>
            {formatter ? formatter(p.value) : p.value}
          </span>
        </div>
      ))}
    </div>
  )
}
